<div class="container-fluid">
  <app-header titleText="{{pageTitle}}"></app-header>
  <div class="ml-md-5">
    <div *ngIf="isIDIAdmio; then idiReports else dealerReports"></div>
    <ng-template #idiReports>
      <div class="row mb-3">
        <div class="col">
          <div class="pr-2">
            <img alt="Reports" src="assets/img/circle_images/reports_circle.png" width="50" />
          </div>
          <div>
            <a routerLink="/report/dealerengagement" class="report-link" i18n>Dealer Engagement Report</a>
            <p i18n>Analyzes the dealer engagement within the Bidit application.</p>
          </div>
        </div>
        <div class="col">
          <div class="pr-2">
            <img alt="Reports" src="assets/img/circle_images/reports_circle.png" width="50" />
          </div>
          <div>
            <a routerLink="/report/dealerlicensure" class="report-link" i18n>Dealer Licensure Report</a>
            <p i18n>Analyzes the dealer licensure within the Bidit application.</p>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          <div class="pr-2">
            <img alt="Reports" src="assets/img/circle_images/reports_circle.png" width="50" />
          </div>
          <div>
            <a routerLink="/report/dealerlogin" class="report-link" i18n>Dealer Login Report</a>
            <p i18n>Analyzes the dealer logins within the Bidit application.</p>
          </div>
        </div>
        <div class="col">
          <div class="pr-2">
            <img alt="Reports" src="assets/img/circle_images/reports_circle.png" width="50" />
          </div>
          <div>
            <a routerLink="/report/dealercontact" class="report-link" i18n>Dealer Contact Report</a>
            <p i18n>Analyzes the dealer contacts within the Bidit application.</p>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="pr-2">
          <img alt="Reports" src="assets/img/circle_images/reports_circle.png" width="50" />
        </div>
        <div>
          <a routerLink="/report/customermetric" class="report-link" i18n>Customer Metrics Report</a>
          <p i18n>Analyzes project metrics for dealers within the Bidit application.</p>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          <div class="pr-2">
            <img alt="Reports" src="assets/img/circle_images/reports_circle.png" width="50" />
          </div>
          <div>
            <a routerLink="/report/emailLog" class="report-link" i18n>Email Log Report</a>
            <p i18n>Review status of previously sent emails</p>
          </div>
        </div>
        <div class="col">
          <div class="pr-2">
            <img alt="Reports" src="assets/img/circle_images/reports_circle.png" width="50" />
          </div>
          <div>
            <a routerLink="/report/smsMessageLog" class="report-link" i18n>SMS Log Report</a>
            <p i18n>Review status of previously sent SMS Messages</p>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #dealerReports>
      <div class="row mb-3">
        <div *ngIf="canViewBidLog" class="col">
          <div class="pr-2">
            <img alt="Reports" src="assets/img/circle_images/reports_circle.png" width="50" />
          </div>
          <div>
            <a routerLink="/report/bidlog" class="report-link" i18n>Bid Log Report</a>
            <p i18n>Analyzes the bid process and historical insights.</p>
          </div>
        </div>
        <div *ngIf="canViewCustomerQuoteContract" class="col">
          <div class="pr-2">
            <img alt="Reports" src="assets/img/circle_images/reports_circle.png" width="50" />
          </div>
          <div>
            <a routerLink="/report/customersummary" class="report-link" i18n>Customer Quote and Contact Report</a>
            <p i18n>Provides customer and quote information</p>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div *ngIf="canViewQuotesByLeadSource" class="col">
          <div class="pr-2">
            <img alt="Reports" src="assets/img/circle_images/reports_circle.png" width="50" />
          </div>
          <div>
            <a routerLink="/report/leadsource" class="report-link" i18n>Quotes by Lead Source</a>
            <p i18n>Assessment of lead sources and success metrics.</p>
          </div>
        </div>
        <div *ngIf="canViewLostQuoteAnalysis" class="col">
          <div class="pr-2">
            <img alt="Reports" src="assets/img/circle_images/reports_circle.png" width="50" />
          </div>
          <div>
            <a routerLink="/report/lostquote" class="report-link" i18n>Lost Quotes Analysis</a>
            <p i18n>Provides expired and lost quotes, detailed by salesperson.</p>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div *ngIf="!quoteOnly && canViewJobCost" class="col">
          <div class="pr-2">
            <img alt="Reports" src="assets/img/circle_images/reports_circle.png" width="50" />
          </div>
          <div>
            <a routerLink="/report/jobcost" class="report-link" i18n>Job Cost Report</a>
            <p i18n>Review job costing compared with bid amounts</p>
          </div>
        </div>
        <div *ngIf="canViewInventory" class="col">
          <div class="pr-2">
            <img alt="Reports" src="assets/img/circle_images/reports_circle.png" width="50" />
          </div>
          <div>
            <a routerLink="/report/inventory" class="report-link" i18n>Inventory Report</a>
            <p i18n>Review item inventory</p>
          </div>
        </div>
      </div>
      <div *ngIf="!quoteOnly && canViewPayrollSummary" class="row mb-3">
        <div class="pr-2">
          <img alt="Reports" src="assets/img/circle_images/reports_circle.png" width="50" />
        </div>
        <div>
          <a routerLink="/report/payrollsummary" class="report-link" i18n>Payroll Summary Report</a>
          <p i18n>Review field technician payroll expenses</p>
        </div>
      </div>
      <div *ngIf="!quoteOnly" class="row mb-3">
        <div *ngIf="canViewEmailLog" class="col">
          <div class="pr-2">
            <img alt="Reports" src="assets/img/circle_images/reports_circle.png" width="50" />
          </div>
          <div>
            <a routerLink="/report/emailLog" class="report-link" i18n>Email Log Report</a>
            <p i18n>Review status of previously sent emails</p>
          </div>
        </div>
        <div *ngIf="canViewSMSLog" class="col">
          <div class="pr-2">
            <img alt="Reports" src="assets/img/circle_images/reports_circle.png" width="50" />
          </div>
          <div>
            <a routerLink="/report/smsMessageLog" class="report-link" i18n>SMS Log Report</a>
            <p i18n>Review status of previously sent SMS Messages</p>
          </div>
        </div>
      </div>

    </ng-template>
  </div>
</div>
